import cloneDeep from 'lodash/cloneDeep'

import {
  ExitActionType,
  GoalStatus,
  GoalType,
  LeadQualExitAction,
  LeadQualGoal,
} from 'shared/api/requests/aiEngagementGoal/schemas'

import { EmptyAssignee } from './constants'
import { ConfigFormValues } from './types'

export const createGoalFromFormValues = ({
  id,
  fields,
  context,
  assignee,
  useWaId,
}: ConfigFormValues & {
  id: string
}): LeadQualGoal => ({
  id,
  type: GoalType.LEAD_QUAL,
  status: GoalStatus.STOPPED,
  ts_updated: new Date().toISOString(),
  data: {
    fields: fields.map((field) => field.fieldId),
    settings: {
      save_phone_as_whatsapp_id: useWaId,
      fallback_assignee: assignee,
      exit_action: null,
    },
    context,
  },
})

export const mapGoalToFormValues = (goal: LeadQualGoal | null): ConfigFormValues => ({
  context: goal ? goal.data.context : '',
  fields: goal ? goal.data.fields.map((field) => ({ fieldId: field })) : [],
  assignee: goal ? goal.data.settings.fallback_assignee : EmptyAssignee,
  useWaId: goal ? goal.data.settings.save_phone_as_whatsapp_id : false,
})

export const mapExitActionToMessageForm = (action: LeadQualExitAction | null) => {
  if (action === null || action.type !== ExitActionType.SEND_MESSAGE) {
    return {
      message: '',
      title: '',
      url: '',
    }
  }

  return {
    message: action.data.message.text,
    title: action.data.message.button?.title ?? '',
    url: action.data.message.button?.url ?? '',
  }
}

export const mergeFormValuesWithGoal = (goal: LeadQualGoal, formValues: ConfigFormValues) => {
  const updatedGoal = cloneDeep(goal)

  updatedGoal.data.context = formValues.context
  updatedGoal.data.fields = formValues.fields.map((field) => field.fieldId)
  updatedGoal.data.settings.fallback_assignee = formValues.assignee
  updatedGoal.data.settings.save_phone_as_whatsapp_id = formValues.useWaId

  return updatedGoal
}

export const mergeExitActionWithGoal = (
  goal: LeadQualGoal,
  exitAction: LeadQualExitAction | null,
) => {
  const updatedGoal = cloneDeep(goal)

  updatedGoal.data.settings.exit_action = exitAction

  return updatedGoal
}
